export default {
  saveRef(name) {
    return node => {
      this[name] = node;
    };
  },
};



// WEBPACK FOOTER //
// ./ext/tabs/src/RefMixin.js